import { createEntityPickerField } from "./createEntityPickerField";
import type { TypedEntityPickerProps } from "./EntityPickerField";
import type { ExpenseTypeId } from "../../api/types";

export type ExpenseTypePickerFieldProps = TypedEntityPickerProps<ExpenseTypeId>;

export const ExpenseTypePickerField =
  createEntityPickerField<ExpenseTypeId>("expense-type");
